import { widgetdocs } from '../constants/widgets'

const { widgets } = widgetdocs
const activeWidgets = Object.keys(widgets)
	.map(key => widgets[key]) // All widgets as an Array
	.filter(widget => widget.obsolete === false) // Filtered to only non-obsolete widgets
	.reduce((newObject, widget) => {
		newObject[widget.name] = widget
		return newObject
	}, {}) // Mapped back to a new object

// Initial State - mapped to state.widgets in the Redux store by combineReducers
const initialState = {
	categories: widgetdocs.categories,
	widgets: activeWidgets,
}

// Reducer
//
// NOTE: A reducer is a 'pure' function. Given the same arguments, it should calculate the next state
//       and return it. No surprises. No side effects. No API calls. No mutations. Just a calculation.
//
// Things you should never do inside a reducer:
//   o Mutate its arguments
//   o Perform side effects like API calls and routing transitions
//   o Call non-pure functions, e.g. Date.now() or Math.random()
//
export default function widgetReducer(state = initialState, action) {
	switch (action.type) {
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/widgetReducer.js